/**
 * Pricing model switches.
 *
 * These are code-level constants, not user-facing settings. They exist so a
 * pricing model can be rolled back quickly by changing one value and rebuilding.
 * Keep each switch in sync with its backend counterpart.
 */

/**
 * Eniq AI pricing model.
 *
 * 'per_user'       — Standard/Pro add-on priced per user, Standard included in
 *                    the Corporate tier. Backend: eniqPricingModePerUser = true
 * 'legacy_minutes' — original plans (start/pro/max/scale) with credits and
 *                    premium models. Backend: eniqPricingModePerUser = false
 *
 * Both sides must be changed together — see docs/PRICING_LOGIC.md.
 */
export const ENIQ_PRICING_MODE = 'per_user';

export const isEniqPerUserMode = () => ENIQ_PRICING_MODE === 'per_user';
